import i18n from '@batical/i18n'
import { RAdoucisseurDiametreDebitSchema_Type } from '@batical/types/src'
import { fetchGenericSorted, fetchGeneric, sortDataSorted } from './GenericQ'
const DataAdoucisseurDiametreDebit: Array<RAdoucisseurDiametreDebitSchema_Type> = require('../json/AdoucisseurDiametreDebit.json')

//adoucissuer
export function fetchdiametreAdoucisseurSorted(): Array<{
  value: string
  label: string
}> {
  return fetchGenericSorted(DataAdoucisseurDiametreDebit)
}

export function fetchdiametreAdoucisseur(uuid: string): RAdoucisseurDiametreDebitSchema_Type | null {
  return fetchGeneric(DataAdoucisseurDiametreDebit, uuid)
}

export function fetchdiametreAdoucisseurFilterDebit(debit: number): string {
  const result = sortDataSorted(
    DataAdoucisseurDiametreDebit.filter((item: RAdoucisseurDiametreDebitSchema_Type) => item.debitmax > debit)
  ).sort((a, b) => a.debitmax - b.debitmax)

  if (result.length > 0) {
    return result[0].name
  }
  return i18n.t('RAdoucisseurDiametreDebit_NOTFOUND')
}
